<template>
  <div class="cart-container">
    <div class="personal-message">
      <span class="floor">{{ $store.state.user_info.position }}F</span>
      <span class="message">{{ $store.state.user_info.department }} · {{ $store.state.user_info.employ_no }}</span>
    </div>
    <div class="break-line"/>
    <div class="own-message">
      <router-link
        v-for="(item, index) in firstRowPersonalData"
        :key="index"
        :to="item.url"
        class="nav-item">
        <div class="tips-container">
          <div v-if="item.title === '我的菜金' && !$store.state.user.is_feedback" class="tip" />
          <img :src="item.picUrl">
        </div>
        <span class="title">{{ item.title }}</span>
      </router-link>
    </div>
    <div class="personal-setting">
      <router-link
        v-for="(item, index) in secondRowPersonalData"
        :key="index"
        :to="item.url"
        class="nav-item">
        <img :src="item.picUrl">
        <span class="title">{{ item.title }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonalCart',
  data () {
    return {
      floor: 2,
      department: '研发部',
      jobNumber: '2018247',
      firstRowPersonalData: [
        {
          title: '我的订单',
          url: '/p/user/order',
          picUrl: require('../../../static/img/personal_cart/icon_wddd.png')
        },
        {
          title: '我的消费',
          url: '/p/user/money',
          picUrl: require('../../../static/img/personal_cart/icon_wdcj.png')
        },
        {
          title: '我的评价',
          url: '/p/user/comment',
          picUrl: require('../../../static/img/personal_cart/icon_wdpj.png')
        }
      ],
      secondRowPersonalData: [
        {
          title: '推荐商家',
          url: '/p/user/recommended_shop',
          picUrl: require('../../../static/img/personal_cart/icon_tjsj.png')
        },
        {
          title: '个人设置',
          url: '/p/user/setting',
          picUrl: require('../../../static/img/personal_cart/icon_grsz.png')
        },
        {
          title: '',
          url: '',
          picUrl: ''
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.cart-container {
  width: 240px;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  .personal-message {
    width: 240px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    .floor {
      height: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #ffffff;
      font-size: 14px;
      padding: 4px 10px;
      background-color: #ff9a28;
      border-radius: 10px;
    }
    .message {
      font-size: 14px;
      margin-left: 5px;
      color: #666666;
    }
  }
  .break-line {
    width: 200px;
    height: 1px;
    margin-top: 15px;
    background-image: url('../../../static/img/personal_cart/break_line.png')
  }
  .own-message, .personal-setting {
    width: 200px;
    height: 50px;
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .nav-item {
      width: 50px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: #333333;
      cursor: pointer;
      text-decoration: none;
      .title {
        margin-top: 5px;
      }
      .tips-container {
        position: relative;
        .tip {
          width: 6px;
          height: 6px;
          position: absolute;
          top: -6px;
          right: -8px;
          border-radius: 50%;
          background: #ff4c4c;
        }
      }
    }
    .nav-item:hover {
      color: #ff4c4c;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/personal_cart/index.vue